import React from 'react';
import PropTypes from 'prop-types';
import { Field } from '@ontruck/orc';
import { useDispatch } from 'react-redux';
import { withFormikField, getFormikError } from 'utils/formik';

import { setCheckTimes } from 'redux/modules/shipper-order-new/duck';

const t = {
  label: 'Units',
};

const NumberOfItemsInput = ({ field, form, ...props }) => {
  const { value, name } = field;
  const { setFieldValue } = form;
  const dispatch = useDispatch();
  return (
    <div>
      <Field
        label={t.label}
        labelType="inner"
        onChange={(e, { value }) => {
          setFieldValue(name, value);
          dispatch(setCheckTimes(true));
        }}
        width="XS"
        value={value || ''}
        invalid={!!getFormikError({ field, form })}
        dataE2E={`shipperOrder_edit__pallets_${field.name}`}
        {...props}
      />
    </div>
  );
};

NumberOfItemsInput.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
};

export default withFormikField(NumberOfItemsInput);
